export default __webpack_public_path__ + "static/media/brandLogo.6cf62cc4.svg";